import { memo } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import AddToCartButton from '@/molecules/ShoppingCard/includes/AddToCartButton'
import { addProductToCart } from '@/store/slices/cart'
import Product from '@/ts/Product'

import { SIZE_WEIGHTS } from './data/weights'
import Fieldset from './includes/Fieldset'

function Form({ product }: FansiCollectionProps) {
  const defaultValues = { size_id: `${product.sizes[0].id}` }
  const form = useForm({ defaultValues })

  const onSubmit = form.handleSubmit(({ size_id }) => {
    const newProduct = { ...product, size_id: +size_id }
    addProductToCart(newProduct)
  })

  return (
    <FormProvider {...form}>
      <form className="space-y-8" onSubmit={onSubmit}>
        <Fieldset
          sizes={product.sizes.sort(
            ({ name: sizeA }, { name: sizeB }) =>
              SIZE_WEIGHTS[sizeA] - SIZE_WEIGHTS[sizeB]
          )}
        />
        {product?.status === 'active' && <AddToCartButton />}
      </form>
    </FormProvider>
  )
}

interface FansiCollectionProps {
  product: Product
}

export default memo(Form)
